import script from "./MdTagSwitcher.vue?vue&type=script&lang=ts"
export * from "./MdTagSwitcher.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__